import pathExposure from './toolEnvironmentExposure'

import quickytoolsRoutes from './quickytools'
import agreementRoutes from './agreements'
import accountRoutes from './account'
import timeInRoutes from './timeIn'
import day6Routes from './day6'
import poseRoutes from './pose'
import debugRoutes from './debug'

export default Vue => {
  const isProduction = Vue.appEnv.isProduction

  // TODO Write tests

  const isPathExposed = p => {
    let isExposed = true
    const exposureLevel = pathExposure[p]
    if (exposureLevel) {
      if (isProduction) {
        isExposed = exposureLevel === 'prod'
      } else {
        const isStaging = Vue.appEnv.environment === 'staging'
        isExposed = !isStaging || exposureLevel === 'stg'
      }
    }
    return isExposed
  }

  // TODO Write tests

  const filterChildPaths = (basePath, children) => {
    return children.filter(c => {
      const path = /^\//.test(c.path) ? c.path : (c.path ? `${basePath}/${c.path}` : basePath)

      const isChildPathExposed = isPathExposed(path)
      if (isChildPathExposed && c.children) {
        c.children = filterChildPaths(path, c.children)
      }
      return isChildPathExposed
    })
  }

  // TODO Write tests

  const routes = [{
    path: '*',
    redirect: '/'
  },
  ...quickytoolsRoutes,
  agreementRoutes,
  accountRoutes,
  timeInRoutes,
  { path: '/day6', redirect: { name: 'day6-main' } },
  ...day6Routes,
  poseRoutes,
  debugRoutes
    // Remember to hide routes if not production ready
  ].filter(p => {
    const isExposed = isPathExposed(p.path)

    if (isExposed && p.children) {
      p.children = filterChildPaths(p.path, p.children)
    }

    return isExposed
  })

  return routes
}
